import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const cookieAccept = this.element.querySelector('#acceptCookies');

        cookieAccept.addEventListener('click', () => {
            this.saveCookies();
            this.element.classList.add('d-none');
        });
    }

    saveCookies() {
        const d = new Date();
        d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toGMTString();

        document.cookie = 'cookie_consent=1;' + expires + ';path=/';

        window.location.reload();
    }
}
